import { format } from 'date-fns/format';
import queryString from 'query-string';
import { useState } from 'react';
import { toast } from 'sonner';

import { useFetch, useTableDataQuery } from '@/modules/common';

import { EventOrder } from '../types';

const currentDate = format(new Date(), 'yyyy-MM-dd');

export function useEventOrdersHistory(
  eventId: string,
  eventName: string,
  selected: string[]
) {
  const fetchClient = useFetch();
  const [isGeneratingReport, setIsGeneratingReport] = useState(false);

  const tableDataQueryResult = useTableDataQuery<EventOrder>({
    url: `/events/${eventId}/orders`,
  });

  const { filters } = tableDataQueryResult;

  const generateReport = async () => {
    setIsGeneratingReport(true);

    try {
      const response = await fetchClient(
        `/events/${eventId}/orders/report-csv?${queryString.stringify(
          {
            orderIds: selected,
            searchText: filters.search,
            statuses: filters.statuses,
          },
          { arrayFormat: 'bracket' }
        )}`,
        {
          method: 'GET',
          asFormData: true,
          responseType: 'blob',
        }
      );
      const blob = new Blob([response], { type: 'text/csv' });
      const url = window.URL.createObjectURL(blob);

      const link = document.createElement('a');
      link.href = url;
      link.download = `${eventName}_report_${currentDate}.csv`;

      document.body.appendChild(link);

      link.click();
      link.remove();

      window.URL.revokeObjectURL(url);
    } catch (error) {
      toast.error(error.message);
    } finally {
      setIsGeneratingReport(false);
    }
  };

  return {
    ...tableDataQueryResult,
    isGeneratingReport,
    generateReport,
  } as const;
}
